var _g, _path, _path2, _path3, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.1,51.3h-3.7v-4.4c0-5.9-3.3-11-8.1-13.5V41c0,4-3.2,7.2-7.2,7.2c-4,0-7.2-3.2-7.2-7.2v-7.8 c-4.9,2.6-8.3,7.7-8.3,13.6v4.4H22c-1.2,0-2.1,0.9-2.1,2.1s0.9,2.1,2.1,2.1h38.1c1.2,0,2.1-0.9,2.1-2.1S61.3,51.3,60.1,51.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2,43.9c1.6,0,2.9-1.3,2.9-2.9v-9.2c-1-0.2-2-0.3-3-0.3c-1,0-1.9,0.1-2.8,0.3V41 C38.2,42.6,39.5,43.9,41.2,43.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1,77.3c-8.9,0-16.1-7.9-16.1-17.6h4c0,7.5,5.4,13.6,12.1,13.6s12.1-6.1,12.1-13.6h4 C57.1,69.4,49.9,77.3,41.1,77.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3,31.5c1.1,0,2.1-0.9,2.1-2.1v-6.5c-0.7-0.1-1.4-0.2-2.1-0.2c-0.7,0-1.3,0.1-2,0.2v6.5 C63.2,30.5,64.2,31.5,65.3,31.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2,57.5v-4c4.3,0,7.9-4,7.9-8.9h4C77.1,51.7,71.8,57.5,65.2,57.5z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78,36.1h-2v-2.6c0-4.1-2.3-7.7-5.7-9.5v5.4c0,2.8-2.3,5-5,5c-2.8,0-5-2.3-5-5v-5.5 C57,25.6,54.7,29,54.5,33c2.1,2.1,3.6,4.6,4.6,7.3H78c1.2,0,2.1-0.9,2.1-2.1S79.2,36.1,78,36.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon);
export default __webpack_public_path__ + "static/media/ServiceIcon.c81ad99d4f6cbb732eb1eceb5c87d3e4.svg";
export { ForwardRef as ReactComponent };